import React from "react";
import { Star, Quote } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { SectionHeading } from "../motion/SectionHeading";
import { Stagger, StaggerItem } from "../motion/Reveal";

export const Testimonials = ({ testimonials = [] }) => {
  const { t, tc } = useLang();
  if (!testimonials.length) return null;
  return (
    <section className="py-10 sm:py-14 bg-white" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <SectionHeading title={t.testimonials.title} center />
        <Stagger className="grid grid-cols-2 md:grid-cols-3 gap-0 mt-6 sm:mt-10">
          {testimonials.map((item) => (
            <StaggerItem key={item.id}>
              <div className="h-full bg-lightgray p-4 sm:p-8 border border-white hover:border-gold/30 transition-colors duration-500" data-testid={`testimonial-${item.id}`}>
                <Quote className="w-5 h-5 sm:w-8 sm:h-8 text-gold/40 mb-3 sm:mb-5" />
                <div className="flex gap-0.5 sm:gap-1 mb-3 sm:mb-4">
                  {Array.from({ length: item.rating || 5 }).map((_, i) => (
                    <Star key={i} className="w-3 h-3 sm:w-4 sm:h-4 text-gold fill-gold" />
                  ))}
                </div>
                <p className="text-charcoal/75 leading-snug sm:leading-relaxed mb-4 sm:mb-6 text-[11px] sm:text-[15px]">“{tc(item.quote)}”</p>
                <div className="flex items-center gap-2 sm:gap-3">
                  <img src={item.image} alt={item.name} className="w-8 h-8 sm:w-11 sm:h-11 rounded-full object-cover" loading="lazy" />
                  <div>
                    <div className="font-semibold text-charcoal text-[11px] sm:text-sm">{item.name}</div>
                    <div className="text-charcoal/50 text-[10px] sm:text-xs">{tc(item.role)}</div>
                  </div>
                </div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
